const DsmSpacing = {
  Fixed0: "var(--spacing-fixed-0)",
  Fixed0_25: "var(--spacing-fixed-0-25)",
  Fixed0_5: "var(--spacing-fixed-0-5)",
  Fixed1: "var(--spacing-fixed-1)",
  Fixed1_5: "var(--spacing-fixed-1-5)",
  Fixed2: "var(--spacing-fixed-2)",
  Fixed2_5: "var(--spacing-fixed-2-5)",
  Fixed3: "var(--spacing-fixed-3)",
  Fixed4: "var(--spacing-fixed-4)",
  Fixed5: "var(--spacing-fixed-5)",
  Fixed6: "var(--spacing-fixed-6)",
  Fixed7: "var(--spacing-fixed-7)",
  Fixed8: "var(--spacing-fixed-8)",
  Fixed9: "var(--spacing-fixed-9)",
  Fixed10: "var(--spacing-fixed-10)",
  Fixed13: "var(--spacing-fixed-13)",
  Fixed15: "var(--spacing-fixed-15)",
  Fixed30: "var(--spacing-fixed-30)",
  Fluid4xs: "var(--spacing-fluid-4xs)",
  Fluid3xs: "var(--spacing-fluid-3xs)",
  Fluid2xs: "var(--spacing-fluid-2xs)",
  FluidXs: "var(--spacing-fluid-xs)",
  FluidS: "var(--spacing-fluid-s)",
  FluidM: "var(--spacing-fluid-m)",
  FluidL: "var(--spacing-fluid-l)",
  FluidXl: "var(--spacing-fluid-xl)",
  Fluid2xl: "var(--spacing-fluid-2xl)",
  Fluid3xl: "var(--spacing-fluid-3xl)",
  Fluid4xl: "var(--spacing-fluid-4xl)"
};
const DsmGridSpacing = {
  DefaultGutterWidth: "var(--grid-default-gutter-width)",
  DefaultMargin: "var(--grid-default-margin)",
  DefaultColumnWidth: "var(--grid-default-column-width)"
};

export { DsmGridSpacing, DsmSpacing };
